import commons from './common/providers.common';

export default angular.module('doxy.providers.video', [commons]).name;
